var _rect, _rect2, _rect3, _path, _path2, _circle, _rect4, _rect5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPushDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 94,
    viewBox: "0 0 64 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.85004,
    y: 7.57983,
    width: 39.8975,
    height: 79.7951,
    rx: 2,
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.1799,
    y: 8.90979,
    width: 37.2377,
    height: 66.4959,
    rx: 1,
    fill: "#266ACA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20.8193,
    y: 7.25,
    width: 15.959,
    height: 5.31967,
    rx: 1,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9247 51.935L25.2889 49.0863C25.4588 49.0476 25.7123 48.9737 25.9267 48.8003C26.263 48.5285 26.3503 48.1623 26.3655 47.8852L26.3832 47.5648L26.1847 47.3127C25.8278 46.8593 25.0852 45.8622 24.4355 44.6559C23.7751 43.4294 23.2672 42.0886 23.2672 40.9231C23.2672 36.8096 26.0492 33.65 28.9701 33.65C31.8994 33.65 34.6723 36.7754 34.6723 40.8245C34.6723 42.0055 34.1529 43.361 33.474 44.6037C32.8061 45.8263 32.0394 46.8406 31.6599 47.315L31.4696 47.5529L31.4737 47.8574C31.4777 48.1548 31.5361 48.5298 31.8223 48.8325C32.0245 49.0465 32.2841 49.1465 32.41 49.1889L37.0371 51.6303C37.809 52.1694 38.2965 52.8033 38.5912 53.3556C38.9029 53.9399 38.975 54.3852 38.975 54.4958V56.35C38.975 57.5375 38.0124 58.5 36.825 58.5H19.225C18.0376 58.5 17.075 57.5375 17.075 56.35V54.4958C17.075 53.9993 17.2798 53.4738 17.6413 52.9945C18.0022 52.5159 18.4782 52.1399 18.9218 51.9363C18.9227 51.9359 18.9237 51.9355 18.9247 51.935Z",
    stroke: "white",
    strokeWidth: 1.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3552 58.3424L46.6438 62.1791L56.5093 51.7654",
    stroke: "#2EA76D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 58.5,
    r: 13.5,
    fill: "#D0021B"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 46.1633,
    y: 65.9032,
    width: 2.9299,
    height: 16.6028,
    rx: 1,
    transform: "rotate(-135 46.1633 65.9032)",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 44.0916,
    y: 54.1633,
    width: 2.9299,
    height: 16.6028,
    rx: 1,
    transform: "rotate(-45 44.0916 54.1633)",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPushDelete);
export default __webpack_public_path__ + "static/media/push-delete.c6eac156ec3f41e31aa0fac43d412858.svg";
export { ForwardRef as ReactComponent };